import React from "react";
import { cn } from "../../lib/utils";

/** A person's photo, or the first letter of their name when there isn't one. */
const Avatar = ({ name, photo, className = "h-8 w-8" }) =>
  photo ? (
    <img
      src={photo}
      alt=""
      referrerPolicy="no-referrer"
      className={cn("flex-shrink-0 rounded-full", className)}
    />
  ) : (
    <div
      className={cn(
        "flex flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-medium",
        className,
      )}
    >
      {name?.[0] || "?"}
    </div>
  );

export default Avatar;
